import { createLogger, createStore } from 'vuex';

export default createStore({
  plugins: [createLogger()],
  state: {},
  mutations: {},
  actions: {},
  modules: {},
});
